<script>
import EtaChartTipoDado from '@/components/eta/EtaChartTipoDado.vue'

export default {
  name: 'EtaShowCharts',
  components: { EtaChartTipoDado },
  props: {
    tiposDiponiveis: {
      type: Array,
      required: true,
    },
    etaId: {
      type: String,
      required: true,
    },
    periodicidade: {
      type: String,
      required: true,
    },
    from: {
      type: Date,
      required: true,
    },
    to: {
      type: Date,
      required: true,
    },
    showDots: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<template>
  <div>
    <div v-if="tiposDiponiveis.length === 0">
      <md-empty-state
        md-rounded
        md-icon="timeline"
        md-label="Nenhum dado disponível"
        md-description="ETA não possui parâmetro para essa periodicidade"
      />
    </div>
    <div v-else class="row">
      <div v-for="e in tiposDiponiveis" :key="e.tipo" class="col-6">
        <div class="">
          <eta-chart-tipo-dado
            :tipo="e.tipo"
            :eta-id="etaId"
            :periodicidade="periodicidade"
            :from="from"
            :to="to"
            :show-dots="showDots"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
